import { Dic } from '$utils'
export const cameraOption = function (that) {
  return {
    add: '新增',
    view: '详情',
    emptyText: that.$t("deviceAccess.message.nodata"),
    stripe: true,
    maxHeight: "100%",
    page: true,
    align: "center",
    menuAlign: "center",
    labelSuffix: '：',
    header: false,
    selection: true,
    delBtn: false,
    editBtn: false,
    labelWidth: '120px',
    column: [
      {
        label: '摄像机名称',
        prop: "deviceName",
        overHidden: true,
        addDisplay: true,
      },
      {
        label: 'IMES摄像机编号',
        prop: "thirdDeviceId",
        overHidden: true,
        addDisplay: true,
      },
      {
        label: '摄像机IP',
        prop: "deviceHost",
        overHidden: true,
        addDisplay: true,
      },
      {
        label: '厂商',
        prop: "factoryName",
        overHidden: true,
        addDisplay: true,
        type: 'select',
        dicData: [
          {
            label: '海康威视',
            value: 'HIKVISION'
          },
          {
            label: '华为',
            value: 'HUAWEI'
          }
        ],
      },
      {
        label: "状态",
        prop: "status",
        overHidden: true,
        addDisplay: true,
        type: 'select',
        dicData: [
          {
            label: '在线',
            value: '1'
          },
          {
            label: '离线',
            value: '0'
          }
        ],
        formatter: function (row, value) {
          return Number(value) === 1 ? '在线' : '离线'
        },
      },
      {
        label: '设备更新时间',
        prop: "createTime",
        overHidden: true,
        addDisplay: true,
      },
      {
        label: '所属通道名称',
        prop: "deviceName",
        overHidden: true,
        addDisplay: true,
      },
      {
        label: "通道状态",
        prop: "status",
        overHidden: true,
        addDisplay: true,
        type: 'select',
        dicData: [
          {
            label: '在线',
            value: '1'
          },
          {
            label: '离线',
            value: '0'
          }
        ],
        formatter: function (row, value) {
          return Number(value) === 1 ? '在线' : '离线'
        },
      },
      {
        label: '通道IP',
        prop: "deviceHost",
        overHidden: true,
        addDisplay: true,
      },
      {
        label: '所属NVR名称',
        prop: "parentDeviceName",
        overHidden: true,
        addDisplay: true,
      },
    ],
  }
}
